<template>
  <div class="msg-warp" @mouseover="stop = true" @mouseleave="stop = false">
    <div class="inner" :class="animate?'animate':''">
      <div v-for="(i,index) in list" :key="index" class="msg-item">{{ i.content }} <span class="f-c-blue pointer" @click="toDetail(i)">查看 > </span></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      animate: false,
      stop: false

    }
  },
  //   watch: {
  //     list() {
  //       this.$nextTick(() => {
  //         this.init()
  //       })
  //     }
  //   },
  created() {
    this.init()
  },
  methods: {
    toDetail(i) {
      if (i.msgType === 1) {
        this.$router.push('/main/manager/settlement-settings')
      } else if (i.msgType === 2) {
        this.$router.push('/main/manager/order')
      } else if (i.msgType === 3) {
        this.$router.push('/main/statistics?tab=2')
      }
    },
    init() {
      if (this.list.length > 0) {
        setInterval(this.scroll, 2000)
      }
    },
    scroll() {
      if (this.stop) return
      this.animate = true // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
      setTimeout(() => { //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
        this.list.push(this.list[0]) // 将数组的第一个元素添加到数组的
        this.list.shift() // 删除数组的第一个元素
        this.animate = false // margin-top 为0 的时候取消过渡动画，实现无缝滚动
      }, 1000)
    }
  }
}
</script>
<style lang="scss">
.msg-warp{
    // transition: all ease 0.5s;
    .animate{
        transition: all ease 1s;
        margin-top: -20px;
    }
}
</style>
